/* eslint-disable no-unused-vars */
import axios from "axios";

// API endpoints
const API_BASE_URL =
  "https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3";
const SOCIAL_ENDPOINT = "/social-content";

/**
 * Fetch policies with pagination and optional filtering
 *
 * @param {number} page - Current page number (1-based)
 * @param {number} pageSize - Number of results per page
 * @param {string} searchTerm - Optional search term to filter policies
 * @param {string} policyArea - Optional policy area to filter by
 * @returns {Promise} - Promise containing paginated policy data
 */
export const fetchLoyalty = async (claim_result, platform, url) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/voter-insight?table=loyalty`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};


export const fetchConcerns = async (claim_result, platform, url) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/voter-insight?table=concerns`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};


export const fetchOnline = async (claim_result, platform, url) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/voter-insight?table=online`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};


export const fetchConsideration = async (claim_result, platform, url) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/voter-insight?table=consideration`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
